import { render, staticRenderFns } from "./story-show.vue?vue&type=template&id=144d3644&"
import script from "./story-show.vue?vue&type=script&lang=js&"
export * from "./story-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports